'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var constants = require('../constants.js');
var styled = _interopDefault(require('styled-components'));

var gridGutterColumn = (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$gutterHalfWidth = _ref.gutterHalfWidth,
    gutterHalfWidth = _ref$gutterHalfWidth === void 0 ? constants.gutterHalfWidth : _ref$gutterHalfWidth;
  return function (component) {
    var GridGutterColumn = styled(component).withConfig({
      componentId: "sc-17uic18-0"
    })(["box-sizing:border-box;padding-left:", ";padding-right:", ";"], gutterHalfWidth, gutterHalfWidth);
    return GridGutterColumn;
  };
});

exports.default = gridGutterColumn;
